module.exports = __webpack_public_path__ + "resources/more.17bd32e22999837f.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-welfare-v2/img/more.png
// module id = 769
// module chunks = 0 2